import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, Router } from '@angular/router';
import { first, map } from 'rxjs/operators';
import { AccessControlService } from '../services/access-control.service';
import { combineLatest, of } from 'rxjs';

// Использование: data: { permission: 'Review' | ['Review','Project'], level: 'view' | 'edit' | 'full' }
export const permissionGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
    const router = inject(Router);
    const ac = inject(AccessControlService);

    const raw = route.data['permission'] as string | string[] | undefined;
    const level = (route.data['level'] as 'view' | 'edit' | 'full') ?? 'view';

    if (!raw) return true;

    const resources = Array.isArray(raw) ? raw : [raw];
    const checks$ = resources.length ? resources.map((r) => ac.can(r, level)) : [of(true)];

    return combineLatest(checks$).pipe(
        map((results) => results.some(Boolean)),
        first(),
        map((allowed) => {
            if (!allowed) {
                router.navigate(['/no-access']);
                return false;
            }
            return true;
        })
    );
};